import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  CardFooter,
  Collapse,
} from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import withRouter from "../../components/Common/withRouter"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import avatar from "../../assets/images/users/avatar-4.jpg"
import { Link } from "react-router-dom"
import PlanCards from "./PlansComponent"
import "./userPayment.css"
import debit from "../../assets/images/debitcard.png"
import paypal from "../../assets/images/paypal.png"
// actions

const PaymentMethod = props => {
  document.title = " Profile | Payment Method"

  const dispatch = useDispatch()

  // const [email, setemail] = useState("")
  const [name, setname] = useState("")
  const [idx, setidx] = useState("")
  const [visible, setVisible] = useState(false)
  const storedUsername = localStorage.getItem("userName")
  const email = localStorage.getItem("userEmail")
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("")

  useEffect(() => {
    console.log("user profile page")
  }, [])

  const handlePaymentMethodSelect = (method) => {
    setSelectedPaymentMethod(method)
  }

  return (
    <React.Fragment>
      <div className="page-content payment-page">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Payment Method" breadcrumbItem="Payment Method" />

          {/* Static Payment Method Container - Never Collapses */}
          <div className="payment-container mt-0">
            {/* Payment Options - Always Visible */}
            <div className="payment-options">
              {/* Credit/Debit Card Option */}
              <div
                onClick={() => handlePaymentMethodSelect('card')}
                className={`payment-option ${selectedPaymentMethod === 'card' ? 'selected' : ''}`}
              >
               <img src={debit} alt=""/>
                <div className="payment-option-text-large">
                  Credit / Debit Card
                </div>
              </div>

              {/* PayPal Option */}
              <div
                onClick={() => handlePaymentMethodSelect('paypal')}
                className={`payment-option ${selectedPaymentMethod === 'paypal' ? 'selected' : ''}`}
              >
                
                <img src={paypal} alt=""/>
                <div className="payment-option-text-large">
                  Paypal
                </div>
              </div>
            </div>

            {/* Proceed Button - Always Visible */}
            <div className="proceed-button-container">
              <button
                onClick={() => {
                  if (selectedPaymentMethod) {
                    // Handle proceed action
                    console.log('Proceeding with:', selectedPaymentMethod)
                  }
                }}
                disabled={!selectedPaymentMethod}
                className={selectedPaymentMethod ? 'proceed-button-enabled' : 'proceed-button-disabled'}
              >
                Proceed
              </button>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PaymentMethod
